import { customAlphabet } from 'nanoid';
import { lowercase } from 'nanoid-dictionary';

export const asClass = (s: string) => `.${s}`;

export const nanoClassId = customAlphabet(lowercase, 10);

export const prefixClassName = (componentId: string) => (suffix: string) =>
	`${componentId}-${suffix}`;
